import React from "react";
import { useTheme } from "../../../CommonComponents/ThemeProvider";

export default function PayButton({ disabled, onClick, children }) {
    const { currentTheme } = useTheme();
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={`w-full py-2 rounded-md font-semibold text-sm transition text-white flex items-center justify-center
                ${disabled
                    ? 'bg-gray-400 cursor-not-allowed'
                    : ''
                }`}
            style={!disabled ? { backgroundColor: currentTheme.color } : {}}
        >
            {children}
        </button>
    );
}
